<template>
  <div>
    <div class="page-content">
      <div class="product-details-top">
        <div class="bg-light pb-5 mb-4">
          <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3 bg-light">
            <div class="container d-flex align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link to="/dashboard">Home</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link to="/casi-clinici">Casi Clinici</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Dettagli {{ clinicalCase.name }}
                </li>
              </ol>
            </div>
            <!-- End .container -->
          </nav>
          <!-- End .breadcrumb-nav -->
          <LoadedComponent :loading="loading" />
          <div class="container" v-if="!loading">
            <div class="card p-4">
              <div class="product-details product-details-centered product-details-separator">
                <h1 class="product-title text-uppercase">
                  {{ clinicalCase?.name }}
                </h1>
                <div v-if="clinicalCase.editable">
                  <router-link :to="'/casi-clinici/update/' + clinicalCase.slug" class="btn btn-primary btn-sm m-2"><i
                      class="las la-edit"></i></router-link>
                  <button type="button" class="btn btn-danger btn-sm" data-toggle="modal"
                    data-target="#delete-clinical-case">
                    <i class="las la-trash-alt"></i>
                  </button>
                </div>

                <div class="product-desc-content text-uppercase">
                  <p>{{ clinicalCase.description }}</p>
                </div>
                <!-- End .product-desc-content -->
              </div>
              <div v-if="attachments.length > 0">
                <attachment-component :attachments="attachments"></attachment-component>
              </div>

              <div class="product-details product-details-centered product-details-separator">
                <div class="row pt-2">
                  <div class="col-md-12">
                    <ul>
                      <li>
                        <strong>Tipologia Caso:</strong>
                        {{ clinicalCase.category_medical }}
                      </li>
                      <li>
                        <strong>Distretto anatomico:</strong>
                        {{ clinicalCase.anatomical_district }}
                      </li>
                      <li>
                        <strong>Trattamenti: </strong>

                        {{
                          clinicalCase.patologies
                            .map(function (elem) {
                              return elem.name;
                            })
                            .join(", ")
                        }}
                      </li>
                    </ul>

                    <div class="product-cat">
                      <div v-if="!clinicalCase.anonymous">
                        <span>Pubblicato da :</span>
                        <span>{{ clinicalCase.full_name }}

                          il {{ clinicalCase.publish_date }}</span>,
                      </div>
                      <div v-else>
                        <span>Caso</span>
                        <span style="font-style: italic">" anonimo "</span><span> pubblicato il:</span>
                        <span> {{ clinicalCase.publish_date }}</span>,
                      </div>
                    </div>
                    <!-- End .product-cat -->
                  </div>
                  <!-- End .col-md-6 -->
                </div>
                <!-- End .row -->
              </div>
            </div>
          </div>
        </div>

        <div class="container" v-if="!loading">
          <div class="product-details-tab bg-white">
            <ul class="nav nav-pills justify-content-center" role="tablist">
              <li class="nav-item">
                <a class="nav-link pt-2 pb-2" id="product-shipping-link " data-toggle="tab" href="#product-shipping-tab"
                  role="tab" aria-controls="product-shipping-tab" aria-selected="false">Test e sondaggi ( {{
                    clinicalCase.count_test }} )
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link active pt-2 pb-2" id="product-review-link " data-toggle="tab"
                  href="#product-review-tab" role="tab" aria-controls="product-review-tab"
                  aria-selected="false">Commenti ({{ clinicalCase.count_comment }})</a>
              </li>
            </ul>

            <div class="tab-content">
              <div class="tab-pane fade" id="product-shipping-tab" role="tabpanel"
                aria-labelledby="product-shipping-link">
                <div class="product-desc-content">
                  <div id="testcomponent">
                    <!-- Componente per i test -->
                    <TestComponent :activity_id_params="clinicalCase?.id"></TestComponent>
                  </div>
                </div>
                <!-- End .product-desc-content -->
              </div>
              <!-- .End .tab-pane -->
              <div class="tab-pane fade show active" id="product-review-tab" role="tabpanel"
                aria-labelledby="product-review-link">
                <div class="alert alert-success mb-4" id="cipriani-comment-success" v-show="successmessagecomment">
                  <h5 class="cipriani-status-message">
                    {{ successmessagecomment }}
                  </h5>
                </div>

                <div class="alert alert-danger mb-4" v-show="errortext">
                  <h5 class="cipriani-status-message">
                    {{ errortext }}
                  </h5>
                </div>
                <div class="reviews">
                  <!-- utenti non possono commentare-->
                  <form class="pb-2" @submit.prevent="sendcomments" v-if="clinicalCase.create_comment">
                    <h3>Commenti {{ comments.length }}</h3>

                    <div class="form-group">
                      <textarea class="form-control mention" name="testo" id="cipriani-text-comment"
                        placeholder="Scrivi il commento" v-model="formcomment.text" required></textarea>
                      <div class="alert alert-danger" v-if="errorsmessage.text">
                        {{ errorsmessage.text[0] }}
                      </div>
                    </div>
                    <!-- End .form-group -->
                    <input type="file" class="neurohub-input-files" ref="fileInput" multiple @change="handleFileUpload"
                      accept="image/jpeg, image/png, application/pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint" />
                    <!-- onchange="changeAttachmentComment()" -->
                    <div class="float-right">
                      <button type="submit" class="btn btn-outline-primary-2 btn-order btn-block">
                        Pubblica il commento
                      </button>
                    </div>
                  </form>

                  <div class="comments-list">
                    <div class="comments-neurohub">
                      <div class="review" style="border-bottom: 0px" v-for="(comment, index) in comments" :key="index">
                        <div class="row no-gutters">
                          <div class="col-sm-2">
                            <h4>
                              <span>{{ comment.full_name }}</span>
                            </h4>
                          </div>
                          <div class="col-sm-10">
                            <div class="review-content">
                              <p>{{ comment.text }}</p>
                            </div>

                            <div class="review-action row">
                              <!-- Regola per bloccare i non utenti-->
                              <button class="btn btn-link" v-if="clinicalCase.create_comment"
                                @click="openModalResponse(comment.id)">
                                <i class="las la-reply"></i>Rispondi
                              </button>
                              <div v-if="comment.attachments.length > 0">
                                |
                                <button type="button" class="btn btn-link" title="view-attachments"
                                  @click="showModalAttachments(comment.id)">
                                  Vedi gli allegati
                                </button>
                              </div>
                            </div>
                            <div v-if="comment.responses.length > 0">
                              <div class="review" style="border-bottom: 0px" v-for="response in comment.responses"
                                :key="response.full_name">
                                <div class="row no-gutters">
                                  <div class="col-auto">
                                    <h4>
                                      <span>{{ response.full_name }}</span>
                                    </h4>
                                  </div>
                                  <!-- End .col -->
                                  <div class="col">
                                    <div class="review-content">
                                      <p>{{ response.text }}</p>
                                    </div>
                                    <!-- End .review-content -->
                                  </div>
                                  <!-- End .col-auto -->
                                </div>
                                <!-- End .row -->
                              </div>
                              <!-- End .review -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End .reviews -->
              </div>
              <!-- .End .tab-pane -->
            </div>
            <!-- End .tab-content -->
          </div>
        </div>
      </div>

      <div class="container" v-if="!loading">
        <h2 class="title text-center mb-4">Casi correlati</h2>
        <SwiperComponents :elements="clinicalCasesLinked" category="1" />
      </div>
    </div>
    <div class="modal fade" id="reponse-comment-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>

            <div class="form-box">
              <div class="form-tab">
                <ul class="nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link" id="signin-tab" data-toggle="tab" href="#signin" role="tab"
                      aria-controls="signin" aria-selected="true">Rispondi al commento</a>
                  </li>
                </ul>
                <div class="tab-content" id="tab-content-5">
                  <div class="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                    <form @submit.prevent="sendresponsecomment">
                      <div class="form-group">
                        <label for="singin-email">Messaggio</label>
                        <textarea class="form-control" id="singin-email" name="testo"
                          placeholder="Inserisci il messaggio" v-model="formresponsecomment.text" required></textarea>
                      </div>
                      <!-- End .form-group -->

                      <div class="alert alert-danger" v-if="errorsmessageResponse.text">
                        {{ errorsmessageResponse.text[0] }}
                      </div>

                      <div class="form-footer">
                        <button type="submit" class="btn btn-outline-primary-2 btn-order btn-block">
                          <span class="btn-text">Invia</span>
                          <span class="btn-hover-text">Pubblica la risposta</span>
                        </button>
                      </div>
                      <!-- End .form-footer -->
                    </form>
                  </div>
                  <!-- .End .tab-pane -->
                </div>
                <!-- End .tab-content -->
              </div>
              <!-- End .form-tab -->
            </div>
            <!-- End .form-box -->
          </div>
          <!-- End .modal-body -->
        </div>
        <!-- End .modal-content -->
      </div>
      <!-- End .modal-dialog -->
    </div>
    <!-- End .modal -->
    <div class="modal fade" tabindex="-1" role="dialog" id="delete-clinical-case">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Eliminazione caso clinico</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="m-4">
              <p>Sei sicuro/a di voler eliminare il caso clinico?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" id="delete-modal-close" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-primary" @click="deleteClinicalCase">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- -->
    <div v-for="comment in comments" :key="comment.id">
      <div v-if="comment.attachments.length > 0">
        <ModalAttachmentsComponent :attachments="comment.attachments" :id="'modal-attachments-comments' + comment.id">
        </ModalAttachmentsComponent>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import AttachmentComponent from "@/components/AttachmentComponent.vue";
import LoadedComponent from "@/components/LoadedComponent.vue";
import SwiperComponents from "@/components/SwiperComponents.vue";
import ModalAttachmentsComponent from "@/components/ModalAttachmentsComponent.vue";
import httpservices from "@/services/httpservices.js";
import TestComponent from "@/components/TestComponent.vue";

import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "ClinicalCasePage",
  props: ["slug"],
  components: {
    AttachmentComponent,
    LoadedComponent,
    SwiperComponents,
    TestComponent,
    ModalAttachmentsComponent,
  },
  setup() {
    const auth = useAuth();
    if (auth.fullName == "")
    {
      window.location.href = "/";
    }

    return {
      auth,
    };
  },
  data() {
    return {
      clinicalCase: {},
      loading: true,
      attachments: [],
      clinicalCasesLinked: [],
      request: {
        model: "activity",
        model_id: 0,
      },
      comments: [],
      errors: [],
      intervalId: null,
      errorsmessage: [],
      errorsmessageResponse: [],
      errortext: "",
      successmessagecomment: "",
      modalAttachments: [],
      formcomment: {
        activity_id: 0,
        text: "",
      },
      formresponsecomment: {
        comment_id: 0,
        text: "",
      },
      showModalAttachment: true,
      selectedFilesComments: {},
      user_id: 0,
      loaded: false,
      initialSlideModal: 0,
      tests: [],
    };
  },
  mounted() {
    const auth = useAuth();
    this.user_id = auth.user_id;
    this.loadClinicalCase();
    this.intervalId = setInterval(() => {
      if (this.clinicalCase.id)
      {
        this.loadComments(this.clinicalCase.id);
      }
    }, 30000);
  },
  created() {
    $(document).on("show.bs.modal", ".modal", function () {
      $(this).appendTo("body");
    });
  },
  beforeUnmount() {
    // pulisce l'intervallo quando il componente viene distrutto
    clearInterval(this.intervalId);
  },
  methods: {
    getOptons(path) {
      return {
        controls: true,
        autoplay: false,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
    showModalAttachments(id) {
      $("#modal-attachments-comments" + id).modal("show");
    },
    async sendresponsecomment() {
      await httpauth
        .post("/comment-response/store", this.formresponsecomment)
        .then((response) => {
          console.log(response.data.message);
          $("#reponse-comment-modal").modal("hide");
          this.successmessagecomment = response.data.message;

          this.loadComments(this.clinicalCase.id);
        })
        .catch((error) => {
          if (error.response && error.response.data.errors)
          {
            this.errorsmessageResponse = error.response.data.errors;
          }
        });
    },
    openModalResponse(commentId) {
      this.formresponsecomment.comment_id = commentId;
      $("#reponse-comment-modal").modal("show");
    },
    handleFileUpload(event) {
      this.selectedFilesComments = Array.from(event.target.files);
    },
    loadAttachment(model_id) {
      this.request.model_id = model_id;
      httpauth
        .post("/attachments/show", this.request)
        .then((response) => {
          var data = response.data.data;
          this.attachments = data;
          for (var i = 0; i < this.attachments.length; i++)
          {
            if (this.attachments[i].cover)
            {
              this.attachments.splice(i, 1);
              break;
            }
          }

          this.loading = false;
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
    uploadAttachmentsComment(successMessageContent, commentId) {
      const formData = new FormData();

      this.selectedFilesComments.forEach((file) => {
        formData.append("files[]", file);
      });
      formData.append("model_id", commentId);
      formData.append("model", "comment");
      formData.append("multiple_file", 1);
      formData.append("returned", 0);
      httpauth
        .post("/attachments/store", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.successmessagecomment = successMessageContent;
          this.formcomment.text = "";
          this.selectedFilesComments = null;
          this.fileInput = null;
          $(".neurohub-input-files").val("");
          if (!response.data.status)
          {
            this.errorsmessage =
              "Commento pubblicato ma caricamento degli allegati fallito";
          }
          this.loadComments(this.clinicalCase.id);
        })
        .catch((error) => {
          console.log(error.response.data.errors);
          this.errorsmessage =
            "Commento pubblicato ma caricamento degli allegati fallito";
          this.loadComments(this.clinicalCase.id);
        });
    },
    async sendcomments() {
      await httpauth
        .post("/comments/store", this.formcomment)
        .then((response) => {
          if (this.selectedFilesComments.length > 0)
          {
            this.uploadAttachmentsComment(
              response.data.message,
              response.data.id
            );
            return;
          }
          console.log(this.clinicalCase.id);
          this.successmessagecomment = response.data.message;
          this.loadComments(this.clinicalCase.id);
          this.formcomment.text = "";
        })
        .catch((error) => {
          this.errorsmessage = error.response.data.errors;
        });
    },
    async loadComments(activity_id) {
      await httpservices
        .loadComments(activity_id)
        .then((response) => {
          this.comments = response.data.data;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    async loadClinicalCase() {
      await httpauth
        .get("/casi-clinici/show/" + this.slug, [
          {
            params: { slug: this.slug }, // Passa l'ID come oggetto nel campo 'data'
          },
        ])
        .then((response) => {
          var data = response.data.data;
          this.clinicalCase = data;

          this.formcomment.activity_id = this.clinicalCase.id;

          this.loadAttachment(this.clinicalCase.id);

          this.loadClinicalCaseLinked(
            this.clinicalCase.anatomical_district_id,
            this.clinicalCase.id
          );
          this.loadComments(this.clinicalCase.id);

          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.status == 403)
          {
            localStorage.setItem(
              "messageErrorClinicalCase",
              error.response.data.message
            );
            window.location.href = "/casi-clinici";
          }
        });
    },
    async loadClinicalCaseLinked(anatomical_district_id, id) {
      var url = "/casi-clinici/collegati/" + anatomical_district_id + "/" + id;
      await httpauth
        .get(url)
        .then((response) => {
          this.clinicalCasesLinked = response.data.data;
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    async deleteClinicalCase() {
      this.loading = true;
      httpauth
        .delete("/casi-clinici/delete/" + this.clinicalCase.slug)
        .then((response) => {
          localStorage.setItem(
            "messageSuccessClinicalCase",
            response.data.message
          );

          $("#delete-modal-close").click();
          this.loading = false;
          window.location.href = "/casi-clinici";
        })
        .catch((error) => {
          this.loading = false;
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            $("#delete-clinical-case").modal("hide");
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          console.log(error);
        });
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    changeSlide(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>
<style scoped>
.btn-link {
  color: #777;
}

.nav.nav-pills .nav-item.show .nav-link,
.nav.nav-pills .nav-item .nav-link.active {
  color: #177fd5;
  border-color: #d7d7d7;
  border-bottom-color: #177fd5;
}
</style>